module.exports = __webpack_public_path__ + "assets/static/png/verifiedpci.441ea15a544bef7259e75436a1c7e055.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/footer/images/verifiedpci.png
 ** module id = 479
 ** module chunks = 1
 **/